<template>
  <div>
    <TagVaries @limit="hide" />

    <div class="content_template" :class="{ limit: limit }">
      <Header />
      <Banner />
      <a-config-provider :locale="zh_CN">
        <router-view v-if="RouterShow"></router-view>
      </a-config-provider>
    </div>

    <!-- <Apply :limit="limit" v-if="!isPage('infos')"/> -->
    <a-back-top ref="ScrollTop" />
  </div>
</template>
<script>
import Header from "./Header";
import TagVaries from "./Tags";
import Banner from "./Banner";
// import Apply from './Apply.vue'
import { myMixin } from "@/mixins/tool.js";

export default {
  name: "pc",
  components: {
    Header,
    TagVaries,
    Banner,
    // Apply
  },
  data() {
    return {
      limit: false,
      links: [],
    };
  },
  watch: {
    getAuth: {
      handler(val, oldval) {
        if (val != oldval) {
          this.setDataLinks();
        }
      },
      deep: true,
    },
    links: {
      handler(val, oldval) {
        if (val != oldval) {
          this.userLoaded();
        }
      },
      deep: true,
    },
  },
  mixins: [myMixin],
  methods: {
    async setDataLinks() {
      var self = this;
      await this.$axios
        .get(`${window.commonApi.INFOPLUS_URL}/me/positions`)
        .then((res) => {
          if (res.data.errno === 0) {
            let userProfile = res.data.entities.map(function (res) {
              return res.post.name;
            });
            if (userProfile.indexOf("教职工") > -1) {
              self.links = [
                {
                  uri: "",
                  name: "出访公示",
                  icon: "project",
                },
                {
                  uri: "",
                  name: "因公出访",
                  icon: "plane",
                },
              ];
            }
            if (
              userProfile.indexOf("本科生") > -1 ||
              userProfile.indexOf("研究生") > -1
            ) {
              self.links = [
                {
                  uri: "",
                  name: "项目列表",
                  icon: "project",
                },
                {
                  uri: "",
                  name: "自主联系项目",
                  icon: "plane",
                },
                {
                  uri: "",
                  name: "国际学术会议参会项目",
                  icon: "invite",
                },
                {
                  uri: "",
                  name: "行前培训",
                  icon: "pass",
                },
                 {
                  uri: "",
                  name: "在外打卡",
                  icon: "",
                },
              ];
            }
          }
        })
        .catch((error) => {
          console.log(error); //请求失败返回的数据
        });
    },
    hide(e) {
      this.limit = e;
    },
    appsFilter: function (apps) {
      return apps.filter((item) => {
        return item.tags && item.tags.indexOf("WSXT") != -1;
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/index.vue